import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import App from './App';

import { isDevMode } from './Utilities/Helpers';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

	(isDevMode()) ? 
		<BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
			<Routes>
				<Route path="*" element={<App />} />
			</Routes>
		</BrowserRouter>
	:
		<React.StrictMode>
			<BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
				<Routes>
					<Route path="*" element={<App />} />
				</Routes>
			</BrowserRouter>
		</React.StrictMode>
);